(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    class WishlistButton extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.storageKey = 'wishlist';
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.updateState(this.isWishlisted());
      this.button.addEventListener('click', this.toggle.bind(this));
    }

    getWishlist() {
      try {
        return JSON.parse(localStorage.getItem(this.storageKey)) || [];
      } catch (error) {
        return [];
      }
    }

    isWishlisted() {
      return this.getWishlist().includes(this.productId);
    }

    toggle() {
      const wishlist = this.getWishlist();
      const index = wishlist.indexOf(this.productId);
      if (index > -1) {
        wishlist.splice(index, 1);
      } else {
        wishlist.push(this.productId);
      }
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
      } catch (error) {
        return;
      }
      this.updateState(index === -1);
    }

    updateState(isActive) {
      this.button.setAttribute('aria-pressed', isActive);
      this.button.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
    }
  }

  customElements.define('wishlist-button', WishlistButton);
  } catch(e) { console.error(e); }
})();

})();
